/*
GPS DataViz

Copyright © 2021 GPSDataViz

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/

import React from "react";
import { Button, Divider } from 'antd';
import '../../Styles/styles-Team.css';
import { OnBoardingNav } from "../Navigation/OnBoardingNav";

import Kerrest from '../../Images/KerrestIMG.png'
import Cronin from '../../Images/CroninIMG.png'
import Grossman from '../../Images/GrossmanIMG.png'


function onChange(a, b, c) {
    console.log(a, b, c);
  }

  export class Team extends React.Component{
    // state = {
    //     username:"",
    //     password: "",
    //     error: "",
    //     logged_in: false
    // }; 

    render(){
        return <>
            <div>
                <OnBoardingNav />
                <div className="team-outer">
                    <div className="team-divider">
                    <p className="team-title">GPS DataViz Team</p>
                        <div className="team-grid">
                            <div className="person-box">
                                <div className="person-photo-outer"><img className="person-photo" src={Kerrest} alt="person-photo"/></div>
                                <p className="person-name">Marc Kerrest</p>
                                <p className="person-title">Founder and CEO</p>
                                <div className="person-divider"><Divider></Divider></div>
                                <p className="person-description">Former college soccer player and commodity derivatives trader for several hedge funds and investment banks, Kerrest developed the original GPS DataViz models while working as Director of Performance Analysis for the Colorado College Women’s Soccer team.</p>
                            </div>
                            <div className="person-box">
                                <div className="person-photo-outer"><img className="person-photo" src={Cronin} alt="person-photo"/></div>
                                <p className="person-name">Kevin Cronin</p>
                                <p className="person-title">VP of Performance Science</p>
                                <div className="person-divider"><Divider></Divider></div>
                                <p className="person-description">Experienced sports science professional with over 15 years working with NCAA and US Military programs, using sports performance data to help athletes achieve peak output across different settings. Cronin refined the GPS DataViz models using industry best practices.</p>
                            </div>
                            <div className="person-box">
                                <div className="person-photo-outer"><img className="person-photo" src={Grossman} alt="person-photo"/></div>
                                <p className="person-name">Robin Grossman</p>
                                <p className="person-title">VP of Business Development</p>
                                <div className="person-divider"><Divider></Divider></div>
                                <p className="person-description">Former college soccer player and current coach with 15 years at the Division I level, Grossman helped tailor the platform to meet coaches’ specific needs. He coached the USA World University team in 2015 and works as a scout for the US Women’s National Team.</p>
                            </div>
                        </div>
                    </div>
                    <div className="search-divider"><Divider></Divider></div>
                    <br/>
                    <br/>
                    <br/>
                </div>
            </div>
        </>
    }
}